export default __webpack_public_path__ + "static/features-phone-languages-82c61000e03a9d734c6a69ffb56f1c6e.png";